import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { api } from './api';

const DataContext = createContext(null);

export function DataProvider({ children }) {
  const [costCenters, setCostCenters] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [projects, setProjects] = useState([]);
  const [assignments, setAssignments] = useState([]);
  const [deviceAssignments, setDeviceAssignments] = useState([]);
  const [devices, setDevices] = useState([]);
  const [dayProjectOrder, setDayProjectOrder] = useState([]);
  const [absences, setAbsences] = useState([]);
  const [holidays, setHolidays] = useState([]);
  const [dayNotes, setDayNotes] = useState([]);
  const [clusterNotes, setClusterNotes] = useState([]);
  const [warnings, setWarnings] = useState(null);
  const [projectHoursSummary, setProjectHoursSummary] = useState({});
  const [loaded, setLoaded] = useState(false);

  const [range, setRange] = useState({ from: '', to: '' });

  const loadAll = useCallback(async (fromDate, toDate) => {
    const years = new Set();
    if (fromDate) years.add(fromDate.slice(0, 4));
    if (toDate) years.add(toDate.slice(0, 4));
    if (years.size === 0) years.add(String(new Date().getFullYear()));

    const [cc, emps, projs, asss, abss, dn, w, phs, das, dvs, dpo, cn] = await Promise.all([
      api.get('/cost-centers', { params: { include_inactive: true } }),
      api.get('/employees', { params: { include_inactive: true } }),
      api.get('/projects', { params: { include_archived: true } }),
      api.get('/assignments', { params: { from_date: fromDate, to_date: toDate } }),
      api.get('/absences', { params: { from_date: fromDate, to_date: toDate } }),
      api.get('/day-notes', { params: { from_date: fromDate, to_date: toDate } }),
      api.get('/warnings', { params: { from_date: fromDate, to_date: toDate } }),
      api.get('/projects-hours-summary'),
      api.get('/device-assignments', { params: { from_date: fromDate, to_date: toDate } }),
      api.get('/devices', { params: { include_inactive: true } }),
      api.get('/day-project-order', { params: { from_date: fromDate, to_date: toDate } }),
      api.get('/cluster-notes', { params: { from_date: fromDate, to_date: toDate } }),
    ]);
    setCostCenters(cc.data);
    setEmployees(emps.data);
    setProjects(projs.data);
    setAssignments(asss.data);
    setAbsences(abss.data);
    setDayNotes(dn.data);
    setClusterNotes(cn.data || []);
    setWarnings(w.data);
    setProjectHoursSummary(phs.data || {});
    setDeviceAssignments(das.data || []);
    setDevices(dvs.data || []);
    setDayProjectOrder(dpo.data || []);

    // Feiertage für alle betroffenen Jahre
    const allHolidays = [];
    for (const y of years) {
      const hr = await api.get('/holidays', { params: { year: parseInt(y) } });
      allHolidays.push(...hr.data);
    }
    setHolidays(allHolidays);
    setLoaded(true);
  }, []);

  const refresh = useCallback(async () => {
    if (range.from && range.to) await loadAll(range.from, range.to);
  }, [range, loadAll]);

  const value = {
    costCenters, employees, projects, assignments, absences, holidays, dayNotes, clusterNotes, warnings, projectHoursSummary, loaded,
    deviceAssignments, devices, dayProjectOrder,
    loadAll, refresh, range, setRange,
    setCostCenters, setEmployees, setProjects, setAssignments, setAbsences, setDayNotes, setClusterNotes,
  };
  return <DataContext.Provider value={value}>{children}</DataContext.Provider>;
}

export const useData = () => useContext(DataContext);
